import { createContext } from "react";

export type TSelectionContextType<T> = {
	selected: Map<string | number, T>;
	selectItem: (item: T) => void;
	clearSelection: () => void;
	isSelected: (item: T) => boolean;
	isAllSelected: () => boolean;
	isIndeterminate: () => boolean;
	selectAll: () => void;
	selectMode: boolean;
	setSelectMode: (value: boolean) => void;
};

export const SelectionContext = createContext<
	TSelectionContextType<object> | undefined
>(undefined);
